/* Policy and help pages (snippets/pol-policy): builds "On this page" from the text's own headings, or, when the text
   has none, from its bold lead lines (a line that is bold from start to end, e.g. "SECTION 1 - ONLINE STORE TERMS",
   "Damages and issues"). Those lead lines are styled as headings; the words are never changed. Wide data tables get a
   scroll box, layout tables become plain blocks. The list sits in a sticky side column on desktop and in the kit
   dropdown (a bottom sheet on phones) below 1024 px; the section being read is marked as you scroll.
   In a text with real headings, a section the editor set as a bold line instead ("SMS Marketing" in Privacy) joins
   the list and is styled like the headings around it.
   Also: links the text wrote without "https://" ("www.allaboutcookies.org") open the real site, and on the help pages
   (Returns) the phone number and email become tap-to-call / tap-to-email links and a street address in a step gets
   its own line. The words are never changed.
   Motion only on interaction: the sheet slides up and back down, jumps are smooth (instant with reduced motion). */
(function () {
  var root = document.querySelector('[data-pol]');
  if (!root || root.hasAttribute('data-pol-ready')) return;
  root.setAttribute('data-pol-ready', '');

  // the hero texture: if it fails to load, hide it rather than show the browser's broken-image box
  root.querySelectorAll('img.bk-tex').forEach(function (img) {
    function hide() { img.style.visibility = 'hidden'; }
    if (img.complete && !img.naturalWidth && img.currentSrc) hide();
    img.addEventListener('error', hide);
  });
  var body = root.querySelector('[data-pol-body]');
  if (!body) return;

  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var BLOCK = 'p, div, li, td, th, h1, h2, h3, h4, h5, h6, blockquote, ul, ol, table, section, article';

  // the policy's own title block is printed by Shopify inside the text; it is not part of the text
  var text = body.querySelector('.rte') || body;
  if (!text.textContent.replace(/\s+/g, '')) {
    root.classList.add('pol--empty');
    return;
  }

  // the sticky header's height, so the side list and jumps clear it
  (function () {
    var hdr = document.querySelector('#shopify-section-header, .shopify-section-group-header-group, header');
    if (!hdr) return;
    var pos = window.getComputedStyle(hdr).position;
    var inner = hdr.querySelector('[class*="header"]');
    if (pos !== 'sticky' && pos !== 'fixed' && inner) pos = window.getComputedStyle(inner).position;
    if (pos === 'sticky' || pos === 'fixed') root.style.setProperty('--pol-top', Math.round(hdr.getBoundingClientRect().height + 24) + 'px');
  })();

  // a link written without "https://" would open as a page of this store (Privacy: www.allaboutcookies.org)
  Array.prototype.forEach.call(text.querySelectorAll('a[href^="www."]'), function (a) {
    a.setAttribute('href', 'https://' + a.getAttribute('href'));
  });

  // help pages (Returns): "(877) 772-4362" and "info@biopharmasci.com" in the text become links (same words), and a
  // bold street address inside a step ("ship back to: 2575 Pioneer Ave #103 Vista, CA 92081") gets its own line
  if (root.classList.contains('pol--page')) {
    var LINKABLE = /(\(?\d{3}\)?[ .\u00a0-]?\d{3}-\d{4})|([\w.+-]+@[\w-]+(?:\.[\w-]+)+)/g;
    var plain = [];
    var texts = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
    while (texts.nextNode()) {
      LINKABLE.lastIndex = 0;
      if (!texts.currentNode.parentElement.closest('a') && LINKABLE.test(texts.currentNode.nodeValue)) plain.push(texts.currentNode);
    }
    plain.forEach(function (node) {
      var value = node.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      var m;
      LINKABLE.lastIndex = 0;
      while ((m = LINKABLE.exec(value))) {
        frag.appendChild(document.createTextNode(value.slice(last, m.index)));
        var a = document.createElement('a');
        a.href = m[1] ? 'tel:+1' + m[1].replace(/\D/g, '') : 'mailto:' + m[2];
        a.textContent = m[0];
        frag.appendChild(a);
        last = m.index + m[0].length;
      }
      frag.appendChild(document.createTextNode(value.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
    Array.prototype.forEach.call(text.querySelectorAll('ol > li > b, ol > li > strong'), function (b) {
      if (!/^\d+ .+\b[A-Z]{2} \d{5}(-\d{4})?$/.test(b.textContent.replace(/\s+/g, ' ').trim())) return;
      b.classList.add('pol-addr');
      // the run of spaces the editor typed before it would hang at the end of the line above
      var before = b.previousSibling;
      if (before && before.nodeType === 3) before.nodeValue = before.nodeValue.replace(/\s+$/, ' ');
    });
  }

  // tables: data tables (two or more cells in a row) scroll inside a box; one-cell layout tables are just blocks
  Array.prototype.forEach.call(text.querySelectorAll('table'), function (table) {
    var wide = Array.prototype.some.call(table.rows, function (row) { return row.cells.length > 1; });
    if (!wide) { table.classList.add('pol-layout'); return; }
    var box = document.createElement('div');
    box.className = 'pol-table';
    table.parentNode.insertBefore(box, table);
    box.appendChild(table);
  });

  function tidy(s) { return s.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim(); }
  // a line set in capitals ("SECTION 5 - PRODUCTS OR SERVICES (if applicable)"); short acronyms ("GDPR") are not
  function caps(s) {
    var letters = s.replace(/[^A-Za-z]/g, '');
    return letters.length > 5 && letters.replace(/[^A-Z]/g, '').length / letters.length >= 0.6;
  }

  // empty lines the editor left at the start and end of the text (a <br>, an empty paragraph) take no room
  function blank(n) {
    if (n.nodeType === 3) return !tidy(n.nodeValue);
    if (n.nodeType !== 1) return true;
    if (n.tagName === 'BR' || window.getComputedStyle(n).display === 'none') return true;
    var media = Array.prototype.some.call(n.querySelectorAll('img, iframe, video, svg'), function (m) {
      return window.getComputedStyle(m).display !== 'none';
    });
    return !media && !tidy(n.textContent);
  }
  function trim(box, fromEnd) {
    var kids = Array.prototype.slice.call(box.childNodes);
    if (fromEnd) kids.reverse();
    for (var i = 0; i < kids.length; i++) {
      var n = kids[i];
      if (blank(n)) { if (n.nodeType === 1) n.style.display = 'none'; continue; }
      if (n.nodeType === 1 && /^(DIV|TABLE|TBODY|TR|TD|SECTION|ARTICLE)$/.test(n.tagName)) trim(n, fromEnd);
      return;
    }
  }
  trim(text, false);
  trim(text, true);

  // 1. headings in the text
  var entries = [];
  var heads = Array.prototype.filter.call(text.querySelectorAll('h1, h2, h3'), function (h) {
    return tidy(h.textContent) && !h.closest('.shopify-policy__title');
  });
  if (heads.length >= 2) {
    var top = Math.min.apply(null, heads.map(function (h) { return +h.tagName.charAt(1); }));
    // a paragraph that is one short bold title and nothing else (no closing stop, not in a list, table or link)
    var bolds = Array.prototype.filter.call(text.querySelectorAll('p'), function (p) {
      var label = tidy(p.textContent);
      if (!label || label.length > 60 || /[.,;:!?]$/.test(label) || p.closest('li, td, th, blockquote') || p.querySelector('a')) return false;
      var b = p.querySelector('strong, b');
      return b && tidy(b.textContent) === label;
    });
    heads.concat(bolds).sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    }).forEach(function (h) {
      if (h.tagName === 'P') {
        h.classList.add('pol-h', 'pol-h--' + top);
        entries.push({ el: h, label: tidy(h.textContent), sub: false });
      } else {
        entries.push({ el: h, label: tidy(h.textContent), sub: +h.tagName.charAt(1) > top });
      }
    });
  } else {
    // 2. bold lead lines: walk the text line by line (a <br> or a new block ends a line)
    var walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    var line = [];
    var lineBlock = null;
    var finish = function () {
      var words = line.filter(function (n) { return tidy(n.nodeValue); });
      line = [];
      if (!words.length) return;
      var label = tidy(words.map(function (n) { return n.nodeValue; }).join(''));
      if (label.length > 90) return;
      var allBold = words.every(function (n) {
        var el = n.parentElement;
        return el.closest('strong, b') && !el.closest('li, td, th, a, h1, h2, h3, h4, h5, h6');
      });
      if (!allBold) return;
      var bolds = [];
      words.forEach(function (n) { var b = n.parentElement.closest('strong, b'); if (bolds.indexOf(b) < 0) bolds.push(b); });
      bolds.forEach(function (b) { b.classList.add('pol-lead'); if (caps(label)) b.classList.add('pol-lead--caps'); });
      entries.push({ el: bolds[0], label: label.replace(/\s*:$/, ''), sub: false });
    };
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (node.nodeType === 1) {
        if (node.tagName === 'BR') finish();
        continue;
      }
      var block = node.parentElement.closest(BLOCK);
      if (block !== lineBlock) { finish(); lineBlock = block; }
      line.push(node);
    }
    finish();
  }

  // the first heading at the very top of the text needs no space above it
  if (entries.length) {
    var first = text.firstElementChild;
    if (first && (first === entries[0].el || first.contains(entries[0].el)) && !tidy(first.textContent).indexOf(entries[0].label)) {
      entries[0].el.setAttribute('data-pol-first', '');
    }
  }

  if (entries.length < 3) {
    if (tidy(text.textContent).length < 1500) root.classList.add('pol--short');
    return;
  }

  // ids from the words themselves
  var used = {};
  entries.forEach(function (e) {
    var slug = e.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
    var id = 'pol-' + slug;
    var n = 2;
    while (used[id] || document.getElementById(id)) id = 'pol-' + slug + '-' + n++;
    used[id] = true;
    if (!e.el.id) e.el.id = id;
    e.el.classList.add('pol-target');
  });

  // the lists (side column + dropdown); all-caps lines read better in sentence case here
  var lists = root.querySelectorAll('[data-pol-toc]');
  var links = [];
  Array.prototype.forEach.call(lists, function (list) {
    var set = [];
    entries.forEach(function (e) {
      var li = document.createElement('li');
      li.className = 'pol-toc__item' + (e.sub ? ' pol-toc__item--sub' : '');
      var a = document.createElement('a');
      a.className = 'pol-toc__link';
      a.href = '#' + e.el.id;
      a.textContent = caps(e.label) ? e.label.charAt(0) + e.label.slice(1).toLowerCase() : e.label;
      li.appendChild(a);
      list.appendChild(li);
      set.push(a);
    });
    links.push(set);
  });
  var aside = root.querySelector('[data-pol-aside]');
  var dd = root.querySelector('[data-pol-dd]');
  var count = root.querySelector('[data-pol-count]');
  if (count) count.textContent = entries.length;
  if (aside) aside.hidden = false;
  if (dd) dd.hidden = false;
  root.classList.add('pol--toc');

  function jump(target, smooth) {
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.scrollIntoView({ behavior: smooth && !calm ? 'smooth' : 'auto', block: 'start' });
    target.focus({ preventScroll: true });
    if (history.replaceState) history.replaceState(null, '', '#' + target.id);
  }

  // the phone sheet / tablet dropdown: it opens with the kit's motion (slides up, the veil fades in) and closes with
  // the same motion reversed. While it is open the chat launcher and the reviews tab step aside (POL_policy.css).
  var summary = dd && dd.querySelector('summary');
  var panel = dd && dd.querySelector('.pol-dd__panel');
  var sheet = window.matchMedia('(max-width: 767px)');
  var closing = null;
  function closeList(refocus) {
    if (!dd || !dd.open || closing) return;
    function done() {
      closing = null;
      dd.open = false;
      if (refocus) summary.focus();
    }
    if (calm || !panel || !panel.animate) { done(); return; }
    var up = sheet.matches;
    var timing = { duration: up ? 260 : 160, easing: 'cubic-bezier(0.4, 0, 0.6, 1)', fill: 'forwards' };
    closing = [panel.animate(up ? { translate: ['0 0', '0 100%'] } : { opacity: [1, 0], translate: ['0 0', '0 -8px'] }, timing)];
    // the veil is the dropdown's ::before (kit); browsers without pseudo-element animation just drop it at the end
    try { closing.push(dd.animate({ opacity: [1, 0] }, Object.assign({ pseudoElement: '::before' }, timing))); } catch (e) {}
    var runs = closing;
    runs[0].onfinish = function () {
      done();
      runs.forEach(function (run) { run.cancel(); });
    };
  }

  root.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.pol-toc__link');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    closeList(false);
    jump(target, true);
  });

  if (dd) {
    summary.addEventListener('click', function (event) {
      if (!dd.open) return;
      event.preventDefault();
      closeList(false);
    });
    dd.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('pol-sheet-open', dd.open);
    });
    // a tap outside, or on the veil (the dropdown's own ::before, so the target is the dropdown itself)
    document.addEventListener('click', function (event) {
      if (dd.open && (!dd.contains(event.target) || event.target === dd)) closeList(false);
    });
    dd.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dd.open) closeList(true);
    });
  }

  // mark the section being read
  var current = -1;
  var ticking = false;
  function mark() {
    ticking = false;
    var edge = parseFloat(window.getComputedStyle(root).getPropertyValue('--pol-top')) || 112;
    var on = -1;
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].el.getBoundingClientRect().top <= edge + 40) on = i; else break;
    }
    if (on === current) return;
    current = on;
    links.forEach(function (set) {
      set.forEach(function (a, i) {
        a.classList.toggle('is-on', i === on);
        if (i === on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(mark); }
  }, { passive: true });
  mark();

  // a link with #section from another page: the ids exist only now
  if (location.hash.length > 1) {
    var start = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (start && root.contains(start)) jump(start, false);
  }
})();
